module.exports = __webpack_public_path__ + "66b4bc6380a7b1fc112c54c55d59e296.svg";